import Directories from 'components/Directories'
import { PROVIDERS, RESULTS_TYPES } from 'utils/DirectoryParser'

const BusinessJobsDirectories = (props) => (
  <Directories
    props={props}
    directoryLabel='Agency/Company Jobs'
    directoryProvider={PROVIDERS.BUSINESS}
    directoryBasePath={PROVIDERS.BUSINESS.jobsBasePath}
    directoryResultsType={RESULTS_TYPES.JOBS}
  />
)

export default BusinessJobsDirectories
